/* eslint-disable jsx-a11y/tabindex-no-positive */
import { useEventListener, useFocus, useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { SimLogViewer } from '../../../components/project/ClerkScreen/SimLogViewer/index';

import {
  AskingBid,
  BidIncrementContainer2,
  BlockStatus,
  Chat,
  ConnectDisconnect,
  ConnectionStatusContainer,
  DecisionButtons,
  EndLane,
  FloorBidderBadge,
  ItemDetails,
  ItemNumber,
  LaneStartButtons,
  Logo,
  OpenItem,
  PauseContinueLane,
  SideNavContainer,
  StartingBidAmount,
  Stats,
  TopBarContainer,
  WatchModeOverlay,
  PreviousDecision
} from 'components/project/ClerkScreen';

import {
  AskingBidContainer,
  AuctionStartContainer,
  BidButton,
  BidButtonsContainer,
  BidModifyButtonsContainer,
  DecisionButtonsContainer,
  Layout,
  PageNavContainer,
  HotKeyLabel,
  StyledBidActivity,
  BidButtonWrapper,
  SellAtBidButton
} from './Styles';
import VAStartStop from "../../../components/project/ClerkScreen/VAStartStop";
import BonusTime from "../../../components/project/ClerkScreen/BonusTime";
import VAModeOverlay from "../../../components/project/ClerkScreen/VAModeOverlay/WatchModeOverlay";

const NPALayout = () => {
  const {
    AuctionStore: {
      auctionID,
      auctionLaneId,
      auctionLaneName,
      auctionList,
      connected,
      getAuctionAndLaneTitle,
      laneClientList,
      laneList,
      laneMetrics,
      laneStatus,
      networkConnected,
      runList,
      runListStats,
        isVirtual,
      isVirtualRunning
    },
    BidStore: {
      auction,
      auctionProduct,
      disableAskingBid,
      lanePaused,
      laneSuspended,
      shouldDisableBidButton,
      shouldDisableFloorBidderOverrideButton,
      shouldDisableOpenItem,
      shouldDisableReRunButton,
      shouldDisableResumeButton,
      shouldDisableRetractBidButton,
      shouldDisableStartingAmountButton,
      shouldDisableStartingBidAmount,
      auctBAFontSize,
    },
    DebuggerStore: { shouldShowLogViewer },
    MessageStore: { auctionLog, directMessageLog, auctionLogObject },
    UIStore: {
      getHotKey,
      handleCurrencyKeyUpFormat,
      handleFloorBidderBidClick,
      handleSetReserveToWinningBidAmount,
      handleFloorBidderOverride,
      handleJoinAuction,
      handleJoinLane,
      handleKeyDown,
      handleLogout,
      handleMonitorChatOnly,
      handleOpenItem,
      handleOpenItemChange,
      handleOpenItemClick,
      handleOpenItemFocus,
      handleOpenItemKeyPress,
      handlePauseLane,
      handleReRun,
      handleResume,
      handleRetractBid,
      handleStartEvent,
      handleStartingBidAmountChange,
      handleStartingBidClick,
      handleStartingBidFocus,
      handleStartingBidKeyPress,
      handleVAToggle,
      handleExtendVATime,
      handlePlayAnnouncements,
      handleStopAnnouncements,
    },
  } = useStores();

  console.log('isVirtualRunning:', isVirtualRunning);
  console.log('isVirtual:', isVirtual);
  const showBidActivity = false;
  const [spaceBarPressedOnBidButton, setSpaceBarPressedOnBidButton] = useState(
    false,
  );
  const [announcementsPressed, setAnnouncementsPressed] = useState(false);
  const [announcementsStopPressed, setAnnouncementsStopPressed] = useState(false);
  const [sellAtBidPressed, setSellAtBidPressed] = useState(false);
  const [bidButtonEl, setBidButtonElFocus] = useFocus();
  const [sellAtBidButtonEl, setSellAtBidButtonElFocus] = useFocus();
  const [startingBidEl, setStartingBidElFocus] = useFocus();
  const [productIdEl, setProductIdElFocus] = useFocus();
  const [floorBidderBadgeEl, setFloorBidderBadgeElFocus] = useFocus();
  const [indvMessageEl, setIndvMessageElFocus] = useFocus();
  const [laneMessageEl, setLaneMessageElFocus] = useFocus();
  const [pinMessageEl, setPinMessageElFocus] = useFocus();

  useEventListener('keydown', handleKeyDown);

  useEffect(() => {
    if (auction.focusOnIndvMessage && indvMessageEl.current) {
      setIndvMessageElFocus();
    }

    if (auction.focusOnLaneMessage && laneMessageEl.current) {
      setLaneMessageElFocus();
    }

    if (auction.focusOnPinMessage && pinMessageEl.current) {
      setPinMessageElFocus();
    }

    const isTypingMessage =
      (auction.focusOnIndvMessage && indvMessageEl.current) ||
      (auction.focusOnLaneMessage && laneMessageEl.current) ||
      (auction.focusOnPinMessage && pinMessageEl.current);

    // console.log('isTypingMessage', isTypingMessage);

    if (!isTypingMessage) {
      if (auction.focusOnProductId && productIdEl.current) {
        setProductIdElFocus();
      }

      if (auction.focusOnFloorBidderBadge && floorBidderBadgeEl.current) {
        setFloorBidderBadgeElFocus();
      }

      if (auction.selectFloorBidderBadge && floorBidderBadgeEl.current) {
        floorBidderBadgeEl.current.select();
      }

      if (auction.focusOnBidButton) {
        if (isVirtual && sellAtBidButtonEl.current) {
          setSellAtBidButtonElFocus();
        } else if (bidButtonEl.current) {
          setBidButtonElFocus();
        }
      }
      // TODO: Don't set focus on starting bid amount if an item is not on the block
      if (auction.focusOnStartingBidAmount && startingBidEl.current) {
        setStartingBidElFocus();
      }
    }
    return () => null;
  }, [
    auction.focusOnProductId,
    auction.focusOnFloorBidderBadge,
    auction.selectFloorBidderBadge,
    auction.focusOnStartingBidAmount,
    auction.focusOnBidButton,
    auction.focusOnIndvMessage,
    auction.focusOnLaneMessage,
    auction.focusOnPinMessage,
    auction.lastUIStateChangeTimestamp,
    floorBidderBadgeEl,
    indvMessageEl,
    bidButtonEl,
    sellAtBidButtonEl,
    laneMessageEl,
    pinMessageEl,
    startingBidEl,
    productIdEl,
    setBidButtonElFocus,
    setSellAtBidButtonElFocus,
    setFloorBidderBadgeElFocus,
    setIndvMessageElFocus,
    setLaneMessageElFocus,
    setPinMessageElFocus,
    setProductIdElFocus,
    setStartingBidElFocus,
    isVirtual,
  ]);

  // Reset "Sell At Bid" pressed state when lot or status changes
  useEffect(() => {
    if (sellAtBidPressed) {
      setSellAtBidPressed(false);
    }
    return () => null;
  }, [auction.lotNumber, auctionProduct?.status]);

  return (
    <>
      <Layout>
        <WatchModeOverlay />
        <VAModeOverlay />
        <TopBarContainer
          connected={connected}
          laneName={auctionLaneName}
          showLogout
          showLaunchPad
          title={getAuctionAndLaneTitle}
        />
        <SideNavContainer
          auctionList={auctionList}
          currentAuctionId={auctionList && auctionID}
          currentLaneId={laneList && auctionLaneId}
          currentLotNumber={auction.lotNumber}
          handleAuctionChange={(e) => handleJoinAuction(e.target.value)}
          handleLaneChange={(e) => handleJoinLane(e.target.value)}
          handleOpenItemClick={handleOpenItemClick}
          laneList={laneList}
          runList={runList}
          totalClerksInLane={laneMetrics && laneMetrics.totalClerks}
          totalClientsInLane={
            laneMetrics &&
            laneMetrics.totalClients - laneMetrics.totalClientsViewOnly
          }
          totalUnitsRemaining={runListStats && runListStats['0']}
          userList={laneClientList}
          zoomLevel={auction.zoomLevel}
        />
        <PageNavContainer>
          <ConnectionStatusContainer
            connected={connected}
            networkConnected={networkConnected}
          />
          <ConnectDisconnect
            connected={connected}
            onCloseConnection={handleLogout}
            onOpenConnection={() =>
              handleStartEvent({
                name: 'Clerk',
                badgeId: 202122,
              })
            }
          />
          <EndLane />
          <PauseContinueLane
            bgColor={!lanePaused ? '#FBCC08' : '#009E0F'}
            bgVariance={20}
            color={!lanePaused ? '#000000' : '#ffffff'}
            icon={lanePaused ? 'fa-play-circle' : 'fa-pause-circle'}
            isLanePaused={lanePaused}
            onClick={handlePauseLane}
            show={laneStatus === 'Running' || laneStatus === 'Paused'}
          />
          {isVirtual && <><VAStartStop
              bgColor={isVirtualRunning ? '#fb6508' : '#009E0F'}
              bgVariance={20}
              color={isVirtualRunning ? '#000000' : '#ffffff'}
              icon={isVirtualRunning ? 'fa-play-circle' : 'fa-pause-circle'}
              isLanePaused={!isVirtualRunning}
              onClick={handleVAToggle}
              currentAuctionId={auctionList && auctionID}
              auctionLaneId={auctionLaneId}
              show={true}
          />
          {isVirtualRunning && <BonusTime bgColor={'#009E0F'}
                     bgVariance={20}
                     color={auction.isVaRunning ? '#000000' : '#ffffff'}
                     icon={auction.isVaRunning ? 'fa-play-circle' : 'fa-hourglass'}
                     isLanePaused={!auction.isVaRunning}
                     onClick={handleExtendVATime}
                     currentAuctionId={auctionList && auctionID}
                     auctionLaneId={auctionLaneId}
                     show={true}/>}
          <VAStartStop
            bgColor="#5b2d8e"
            bgVariance={20}
            color="#ffffff"
            icon="fa-bullhorn"
            iconOnly
            pressed={announcementsPressed}
            isLanePaused={false}
            onClick={() => {
              handlePlayAnnouncements(auctionLaneId);
              setAnnouncementsPressed(true);
              setTimeout(() => setAnnouncementsPressed(false), 1500);
            }}
            show
            currentAuctionId={auctionList && auctionID}
            auctionLaneId={auctionLaneId}
          />
          <VAStartStop
            bgColor="#c0392b"
            bgVariance={20}
            color="#ffffff"
            icon="fa-stop-circle"
            iconOnly
            pressed={announcementsStopPressed}
            isLanePaused={false}
            onClick={() => {
              handleStopAnnouncements(auctionLaneId);
              setAnnouncementsStopPressed(true);
              setTimeout(() => setAnnouncementsStopPressed(false), 1500);
            }}
            show
            currentAuctionId={auctionList && auctionID}
            auctionLaneId={auctionLaneId}
          />
          </>
          }


        </PageNavContainer>
        <Logo
          alt="National Powersport Auctions"
          url={`${process.env.PUBLIC_URL}/assets/logo-inverse.png`}
        >
          <Stats />
        </Logo>
        <ItemNumber />
        <BlockStatus />
        <ItemDetails />
        <AuctionStartContainer>
          <OpenItem
            buttonDisabled={
              !connected ||
              !auction.openItemNumberEntered ||
              auction.openItemNumberEntered === '' ||
              lanePaused ||
              laneSuspended
            }
            buttonIcon="fa-search"
            buttonTabIndex={2}
            inputDisabled={shouldDisableOpenItem}
            inputRef={productIdEl}
            inputTabIndex={1}
            labelText="Open Item #"
            maxLength={5}
            onChange={handleOpenItemChange}
            onClick={handleOpenItem}
            onFocus={handleOpenItemFocus}
            onKeyPress={handleOpenItemKeyPress}
            onKeyUp={() => null}
            placeholderText=""
            testId="open-item-num"
            value={auction.openItemNumberEntered || ''}
          />
          <StartingBidAmount
            buttonDisabled={shouldDisableStartingAmountButton}
            buttonIcon="fa-play-circle"
            buttonTabIndex={4}
            inputDisabled={shouldDisableStartingBidAmount}
            inputRef={startingBidEl}
            inputTabIndex={3}
            labelText="Starting Bid Amount"
            maxLength={11}
            minStartPrice={auctionProduct?.minStartPrice || 0}
            onChange={handleStartingBidAmountChange}
            onClick={() => {
              setBidButtonElFocus();
              handleStartingBidClick(auction.startingBidAmountEntered);
            }}
            onFocus={handleStartingBidFocus}
            onKeyPress={handleStartingBidKeyPress}
            onKeyUp={handleCurrencyKeyUpFormat}
            placeholderText=""
            testId="starting-bid-amt"
            value={auction.startingBidAmountEntered || ''}
          />
          <LaneStartButtons
            disableReRun={shouldDisableReRunButton}
            disableResume={shouldDisableResumeButton}
            handleReRunClick={handleReRun}
            handleResumeClick={handleResume}
          />
        </AuctionStartContainer>
        <BidIncrementContainer2 />
        <AskingBidContainer>
          <AskingBid disabled={disableAskingBid} />
          <BidButtonsContainer>

            <BidButtonWrapper>
              {isVirtual && (
                <SellAtBidButton
                  data-testid="sell-at-bid-button"
                  disabled={shouldDisableBidButton}
                  pressed={sellAtBidPressed}
                  onClick={() => {
                    if (spaceBarPressedOnBidButton) {
                      setSpaceBarPressedOnBidButton(false);
                      return;
                    }
                    setSellAtBidPressed(true);
                    handleSetReserveToWinningBidAmount();
                  }}
                  onKeyDown={(e) => {
                    if (e.which === 32) {
                      setSpaceBarPressedOnBidButton(true);
                    }
                  }}
                  ref={sellAtBidButtonEl}
                  tabIndex={5}
                >
                  Sell At Bid
                  <HotKeyLabel>
                    {getHotKey('target', 'BID') && getHotKey('target', 'BID').label}
                  </HotKeyLabel>
                </SellAtBidButton>
              )}

              <BidButton
                data-testid="bid-button"
                disabled={shouldDisableBidButton}
                width={isVirtual ? '50%' : '100%'}
                onClick={() => {
                  if (spaceBarPressedOnBidButton) {
                    setSpaceBarPressedOnBidButton(false);
                    return;
                  }
                  handleFloorBidderBidClick();
                }}
                onKeyDown={(e) => {
                  if (e.which === 32) {
                    setSpaceBarPressedOnBidButton(true);
                  }
                }}
                ref={bidButtonEl}
                tabIndex={5}
              >
                Bid
                <HotKeyLabel>
                  {getHotKey('target', 'BID') && getHotKey('target', 'BID').label}
                </HotKeyLabel>
              </BidButton>

            </BidButtonWrapper>

            <BidModifyButtonsContainer>
              <button
                className="primary retract-bid"
                disabled={shouldDisableRetractBidButton}
                onClick={handleRetractBid}
                type="button"
              >
                Retract Bid
                <HotKeyLabel>
                  {getHotKey('target', 'RETRACT BID') &&
                    getHotKey('target', 'RETRACT BID').label}
                </HotKeyLabel>
              </button>
              <button
                className="primary floor-bid-override"
                disabled={shouldDisableFloorBidderOverrideButton}
                onClick={handleFloorBidderOverride}
                type="button"
              >
                Floor Bidder Override
                <HotKeyLabel class="smallHotKeyLabel">
                  {getHotKey('target', 'HANDLE FLOOR BID OVERRIDE') &&
                      getHotKey('target', 'HANDLE FLOOR BID OVERRIDE').label}
                </HotKeyLabel>
              </button>
            </BidModifyButtonsContainer>
          </BidButtonsContainer>
        </AskingBidContainer>
        <DecisionButtonsContainer>
          <DecisionButtons source="clerk" />
          <FloorBidderBadge inputRef={floorBidderBadgeEl} />
        </DecisionButtonsContainer>
        <Chat
          auctionLog={auctionLog}
          directMessageLog={directMessageLog}
          handleMonitorChatOnly={handleMonitorChatOnly}
          indvMessageRef={indvMessageEl}
          laneMessageRef={laneMessageEl}
          pinMessageRef={pinMessageEl}
          setIndvMessageElFocus={setIndvMessageElFocus}
          setLaneMessageElFocus={setLaneMessageElFocus}
          setPinMessageElFocus={setPinMessageElFocus}
          showBidActivity={showBidActivity}
          subTitle="National Powersport Auctions"
          title={getAuctionAndLaneTitle}
        />

        {shouldShowLogViewer && <SimLogViewer />}
      </Layout>
    </>
  );
};

export default observer(NPALayout);
